import * as React from 'react';
import { HeaderDesktopUserDetails } from './header-desktop-user-details/header-desktop-user-details';
import { HeaderNotLoggedInView } from './header-not-logged-in-view/header-not-logged-in-view';
import { composer } from '../../../component-decorators/composer';
import { useConfigContext } from '../../../config-context';
export var HeaderUserDetails = composer()
    .withMarketplaceStore()
    .withExperiments()
    .compose(function (_a) {
    var marketplaceStore = _a.marketplaceStore;
    var base = marketplaceStore.route.currentUrl
        ? marketplaceStore.route.currentUrl
        : 'www.wix.com/app-market';
    // tslint:disable-next-line: react-hooks-nesting
    var locale = useConfigContext().locale;
    return marketplaceStore.userName && marketplaceStore.userImage ? (React.createElement(HeaderDesktopUserDetails, { username: marketplaceStore.userName, logoutLink: "https://www.wix.com/signout?redirectTo=" + base
            .split('/app-market')[0]
            .concat('/app-market') })) : (React.createElement(HeaderNotLoggedInView, { signinLink: "https://users.wix.com/signin?loginDialogContext=login&referralInfo=HEADER&overrideLocale=" + locale + "&postLogin=" + base
            .split('/app-market')[0]
            .concat('/app-market') + "&postSignUp=" + base
            .split('/app-market')[0]
            .concat('/app-market') }));
});
//# sourceMappingURL=header-user-details.js.map